export default __webpack_public_path__ + "static/media/ajax-loader.f3718dcf.gif";